import clsx from "clsx";
import { makeStyles } from "tss-react/mui";

import { Box, BoxProps } from "@mui/material";
import { Theme } from "@mui/material/styles";

const settingsContentSizes = {
    medium: 800,
    large: 1000,
    xlarge: 1200,
} as const;

export type SettingsContentSize = keyof typeof settingsContentSizes;

type SettingsContentWrapperProps = BoxProps & {
    size?: SettingsContentSize;
    children: React.ReactNode;
};

const useStyles = makeStyles<{ maxWidth: number }>()((theme: Theme, { maxWidth }) => ({
    wrapper: {
        maxWidth,
        width: "100%",
        alignSelf: "center",
        minWidth: 0,
    },
}));

export const SettingsContentWrapper = ({ size = "medium", children, className, ...boxProps }: SettingsContentWrapperProps) => {
    const maxWidth = settingsContentSizes[size];
    const { classes } = useStyles({ maxWidth });

    return (
        <Box className={clsx(classes.wrapper, className)} {...boxProps}>
            {children}
        </Box>
    );
};
